import { render } from "./settings-user-teams.vue?vue&type=template&id=81fce72e"
import script from "./settings-user-teams.vue?vue&type=script&lang=js"
export * from "./settings-user-teams.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Usuario\\Documents\\Git-Repositorios\\edge_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__